import { Fragment, useContext } from "react";
import { FiAlertCircle, FiFileText, FiGift, FiPhoneIncoming, FiUsers, FiShield, FiShoppingBag, FiX, FiHelpCircle } from "react-icons/fi";
import './index.scss'
import { AppContext } from "App";
import { DropDown } from "components/DropDown";
import { Link } from "react-router-dom";
import { BsBagCheck } from "react-icons/bs";

interface Props { }

export function FloatingCategory(props: Props) {
    const { categoryShow, handleCloseCategory, cat_sub_cat } = useContext(AppContext)

    return (
        <Fragment>
            {categoryShow && (
                <Fragment>
                    <div className="floatingCategory">
                        <div className="floatingCategory-top border-bottom">
                            <div className="floatingCategory-top-name">
                                <i><FiShoppingBag /></i>
                                <span>p-shop</span>
                            </div>
                            <i className="floatingCategory-top-close" onClick={handleCloseCategory}>
                                <FiX />
                            </i>
                        </div>

                        <div className="floatingCategory-bottom">
                            <div className="floatingCategory-bottom-top">
                                ALL categories
                            </div>
                            <div className="border-bottom"></div>
                            <div className="floatingCategory-bottom-content">
                                {
                                    cat_sub_cat.map(i => (<DropDown key={i.name} img={i.img} handleCloseCategory={handleCloseCategory} name={i.name} list={i.sub_cat} />))
                                }
                            </div>
                            <div className="floatingCategory-bottom-footer">
                                <div className="floatingCategory-bottom-footer-title">pages</div>
                                <div className="border-bottom"></div>
                                <div className="floatingCategory-bottom-footer-links">
                                    <Link className="floatingCategory-bottom-footer-links-link" to='offer' onClick={handleCloseCategory}>
                                        <i>
                                            <FiGift />
                                        </i>
                                        <span>
                                            offer
                                        </span>
                                    </Link>
                                    <Link className="floatingCategory-bottom-footer-links-link" to='checkout' onClick={handleCloseCategory}>
                                        <i>
                                            <BsBagCheck />
                                        </i>
                                        <span>
                                            checkout
                                        </span>
                                    </Link>
                                    <Link className="floatingCategory-bottom-footer-links-link" to='faq' onClick={handleCloseCategory}>
                                        <i>
                                            <FiHelpCircle />
                                        </i>
                                        <span>
                                            FAQ
                                        </span>
                                    </Link>
                                    <Link className="floatingCategory-bottom-footer-links-link" to='about-us' onClick={handleCloseCategory}>
                                        <i>
                                            <FiUsers />
                                        </i>
                                        <span>
                                            about us
                                        </span>
                                    </Link>
                                    <Link className="floatingCategory-bottom-footer-links-link" to='contact-us' onClick={handleCloseCategory}>
                                        <i>
                                            <FiPhoneIncoming />
                                        </i>
                                        <span>
                                            contact us
                                        </span>
                                    </Link>
                                    <Link className="floatingCategory-bottom-footer-links-link" to='privacy-policy' onClick={handleCloseCategory}>
                                        <i>
                                            <FiShield />
                                        </i>
                                        <span>
                                            privacy policy
                                        </span>
                                    </Link>
                                    <Link className="floatingCategory-bottom-footer-links-link" to='terms-&-conditions' onClick={handleCloseCategory}>
                                        <i>
                                            <FiFileText />
                                        </i>
                                        <span>
                                            terms & conditions
                                        </span>
                                    </Link>
                                    <Link className="floatingCategory-bottom-footer-links-link" to='404' onClick={handleCloseCategory}>
                                        <i>
                                            <FiAlertCircle />
                                        </i>
                                        <span>
                                            404
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="close-shadow" onClick={handleCloseCategory}>

                    </div>
                </Fragment>
            )}
        </Fragment>

    )
}